module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Log","trip":"Trip","order":"Order","map":"Map"},"no":{"title":"Logg","trip":"Tur","order":"Oppdrag","map":"Kart"}}')
  delete Component.options._Ctor
}
